import staff from './staff'
import workMode from './work-mode'

export default [
  ...staff,
  ...workMode,
]
